export const theme = {
  colors: {
    // Primary brand colors
    primary: "#03a9f4", // verae-500
    secondary: "#9a72e9", // purple-500
    
    // UI colors
    background: "#f8f9fc", // light background
    foreground: "#1e293b", // dark text
    card: "#ffffff",
    cardForeground: "#1e293b",
    text: "#1e293b", // Main text color
    textMuted: "#64748b", // Secondary text color
    
    // Accent colors
    verae: {
      50: "#e1f5fe",
      100: "#b3e5fc",
      200: "#81d4fa",
      300: "#4fc3f7",
      400: "#29b6f6",
      500: "#03a9f4",
      600: "#039be5",
      700: "#0288d1",
      800: "#0277bd",
      900: "#01579b",
      950: "#01426e",
    },
    purple: {
      50: "#f8f6fe",
      100: "#f1edfd",
      200: "#e5ddfb",
      300: "#d0c1f7",
      400: "#b59df1",
      500: "#9a72e9",
      600: "#8752de",
      700: "#743dcc",
      800: "#6233a8",
      900: "#512c88",
      950: "#31184f",
    },
    
    // Status colors
    success: "#10b981",
    error: "#ef4444",
    warning: "#f59e0b",
    info: "#3b82f6",
    
    // Text colors (duplicated for backward compatibility)
    mutedText: "#64748b",
    
    // Border colors
    border: "#e2e8f0",
    
    // Component-specific colors
    navBackground: "#ffffff",
    navText: "#1e293b",
    buttonPrimary: "#03a9f4",
    buttonSecondary: "#9a72e9",
  },
  
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
    "3xl": "64px",
  },
  
  breakpoints: {
    xs: "480px",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },
  
  borderRadius: {
    sm: "0.25rem",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "1rem",
    full: "9999px",
  },
  
  fontFamily: {
    sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    heading: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    mono: "'Roboto Mono', 'SF Mono', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', monospace",
  },
  
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },
};

export type Theme = typeof theme;
